/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LanguageOutReason } from './languageOutReason';

export interface LanguageOut {
  language: string;
  retranscribe: boolean;
  reason?: LanguageOutReason;
  remaining_successful?: number | null;
  remaining_attempts?: number | null;
}
